import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import * as getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const debug =
  process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'testing'

const store = new Vuex.Store({
  state: {
    activeTab: '',
    query: {
      city: [],
      skills: [],
      experiences: [],
      educations: [],
      languages: [],
      asylumStatus: []
    },
    modal: '',
    results: {
      hits: [],
      total: 0
    },
    hasSearched: false,
    noResults: false,
    error: null,
    skip: 0,
    limit: 10,
    strict: true,
    loggedIn: false,
    sort: 'relevance',
    permissions: [],
    cities: [],
    userMessage: {
      bodyEn: '',
      bodySv: '',
      bodyAr: '',
      bodyFa: '',
      bodySo: '',
      bodyTi: '',
      subjectEn: '',
      subjectSv: '',
      subjectAr: '',
      subjectFa: '',
      subjectSo: '',
      subjectTi: '',
      fallbackToEnglish: false
    },
    tree: {
      experiences: {
        columnOne: [],
        columnTwo: [],
        columnThree: []
      },
      skills: {
        columnOne: [],
        columnTwo: [],
        columnThree: []
      },
      locations: {
        columnOne: [],
        columnTwo: [],
        columnThree: []
      }
    },
    searchStats: {
      emailCount: 0,
      languagesUsed: [],
      phoneNumberCount: 0,
      savedSearchId: null,
      totalCount: 0
    }
  },

  getters,
  mutations,

  strict: debug,
  plugins: debug ? [createLogger()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js